export enum ElementType {
    CAROUSEL = 'carousel',
}
